module.exports = __webpack_public_path__ + "assets/images/minus_purple.svg?5a9ab99ed164cf5dd6261e55e06a4cd5";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/minus_purple.svg
// module id = 607
// module chunks = 0